import React from 'react'
import { Link } from 'react-router-dom'
import i18n from '../../../../i18n'
import { LegalFormalityIndexTableType } from './types'
import { ColumnType } from 'antd/es/table'
import { Tooltip } from 'antd'

export const formalitiesStatusesList = () => {
  return i18n.t('legalFormalities:status.name', {
    returnObjects: true,
  })
}

export const formalitiesStatusesOptionsList = () => {
  return Object.entries(formalitiesStatusesList()).map(([key, name]) => {
    return {
      text: name,
      value: key,
    }
  })
}

export const defaultFormalityStatuses = () => formalitiesStatusesOptionsList()

export const formalitiesStatusDefaultValues = () =>
  defaultFormalityStatuses().map((option: any) => {
    return option.value
  })

export const getFormalitiesStatusColumnSearchProps = (
  variables: any,
  dataIndex: string
): ColumnType<LegalFormalityIndexTableType> => ({
  defaultFilteredValue: formalitiesStatusDefaultValues(),
  filterResetToDefaultFilteredValue: true,
  filtered: !!variables.filters?.[`${dataIndex}`],
  filteredValue: variables.filters?.[`${dataIndex}`],
  filters: formalitiesStatusesOptionsList(),
})

export const productIdentificationTokensList = () => {
  return i18n.t('products:identificationToken', {
    returnObjects: true,
  })
}

export const productIdentificationTokensOptionsList = () => {
  return Object.entries(productIdentificationTokensList()).map(
    ([key, name]) => {
      return {
        text: name,
        value: key,
      }
    }
  )
}

export const getProductIdentificationTokenColumnSearchProps = (
  variables: any,
  dataIndex: string
): ColumnType<LegalFormalityIndexTableType> => ({
  filtered: !!variables.filters?.[`${dataIndex}`],
  filteredValue: variables.filters?.[`${dataIndex}`],
  filters: productIdentificationTokensOptionsList(),
})

export const legalStatusOptions = [
  { text: 'SASU', value: 'SASU' },
  { text: 'SAS', value: 'SAS' },
  { text: 'SARL', value: 'SARL' },
  { text: 'EURL', value: 'EURL' },
  { text: 'SA', value: 'SA' },
  { text: 'SCI', value: 'SCI' },
  { text: 'SNC', value: 'SNC' },
  { text: 'SCOP SARL', value: 'SCOP SARL' },
  { text: 'Association', value: 'Association' },
  { text: 'Micro entrepreneur', value: 'Micro entrepreneur' },
  { text: 'Auto entrepreneur', value: 'Auto entrepreneur' },
  { text: 'Entreprise individuelle', value: 'Entreprise individuelle' },
]

export const getLegalStatusColumnSearchProps = (
  variables: any,
  dataIndex: string
): ColumnType<LegalFormalityIndexTableType> => ({
  filtered: !!variables.filters?.[`${dataIndex}`],
  filteredValue: variables.filters?.[`${dataIndex}`],
  filters: legalStatusOptions,
})

export const buildCellLink = (url: string, innerLink: any) => {
  return <Link to={url}>{innerLink}</Link>
}

const columnSortOrder = (variables: any, columnName: string) =>
  variables.sorter?.field === columnName ? variables.sorter.order : false

const adminColumns = (t: any, variables: any, canFullAccess: boolean) =>
  // canFullAccess ? [] : []
  []

export const columns = (
  t: any,
  variables: any,
  canFullAccess: boolean,
  legalisteData: any
) => [
  {
    title: 'Adresse mail',
    dataIndex: 'email',
    key: 'email',
    width: 200,
    ellipsis: { showTitle: false },
    sorter: true,
    sortOrder: columnSortOrder(variables, 'email'),
    render: (text: string) =>
      text ? (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ) : null,
  },
  {
    title: "Nom de l'entreprise",
    dataIndex: 'societyName',
    key: 'societyName',
    width: 180,
    ellipsis: { showTitle: false },
    sorter: true,
    sortOrder: columnSortOrder(variables, 'societyName'),
    render: (text: string) =>
      text ? (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ) : null,
  },
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'id'),
    render: (text: string, record: LegalFormalityIndexTableType) =>
      buildCellLink(
        `/contacts/${record.contactId}/legal_formalities/${record.id}`,
        record.id
      ),
  },
  {
    title: 'Statut',
    dataIndex: 'legalFormalityStatus',
    key: 'legalFormalityStatus',
    width: 140,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'legalFormalityStatus'),
    ...getFormalitiesStatusColumnSearchProps(variables, 'legalFormalityStatus'),
  },
  {
    title: 'Complétion formulaire',
    dataIndex: 'formReceivedAt',
    key: 'formReceivedAt',
    width: 130,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'formReceivedAt'),
  },
  {
    title: 'Premier contact',
    dataIndex: 'documentGeneratedAt',
    key: 'documentGeneratedAt',
    width: 130,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'documentGeneratedAt'),
  },
  {
    title: 'Envoi projet statut',
    dataIndex: 'waitingCapitalDepositAt',
    key: 'waitingCapitalDepositAt',
    width: 130,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'waitingCapitalDepositAt'),
  },
  {
    title: 'Envoi signature',
    dataIndex: 'signatureSentAt',
    key: 'signatureSentAt',
    width: 130,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'signatureSentAt'),
  },
  {
    title: 'Signature',
    dataIndex: 'signatureSignedAt',
    key: 'signatureSignedAt',
    width: 120,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'signatureSignedAt'),
  },
  {
    title: 'Dépôt greffe',
    dataIndex: 'legalAuthorityDroppedAt',
    key: 'legalAuthorityDroppedAt',
    width: 120,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'legalAuthorityDroppedAt'),
  },
  {
    title: 'Formalité',
    dataIndex: 'productIdentificationToken',
    key: 'productIdentificationToken',
    width: 150,
    ellipsis: { showTitle: false },
    sorter: true,
    sortOrder: columnSortOrder(variables, 'productIdentificationToken'),
    ...getProductIdentificationTokenColumnSearchProps(
      variables,
      'productIdentificationToken'
    ),
    render: (text: string) =>
      text ? (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ) : null,
  },
  {
    title: 'Forme juridique',
    dataIndex: 'legalStatus',
    key: 'legalStatus',
    width: 140,
    ...getLegalStatusColumnSearchProps(variables, 'legalStatus'),
  },
  {
    title: 'Validation',
    dataIndex: 'legalAuthorityValidatedAt',
    key: 'legalAuthorityValidatedAt',
    width: 120,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'legalAuthorityValidatedAt'),
  },
  {
    title: 'Observations',
    dataIndex: 'internalNotes',
    key: 'internalNotes',
    ellipsis: { showTitle: false },
    width: 250,
    render: (text: string) =>
      text ? (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ) : null,
  },
  ...adminColumns(t, variables, canFullAccess),
  {
    title: 'Date de paiement',
    dataIndex: 'paidAt',
    key: 'paidAt',
    width: 120,
    sorter: true,
    sortOrder: columnSortOrder(variables, 'paidAt'),
  },
  {
    title: 'ID DOM',
    dataIndex: 'domiciliationId',
    key: 'domiciliationId',
    width: 90,
    render: (text: string, record: LegalFormalityIndexTableType) =>
      record.domiciliationId && record.domiciliationId !== 0
        ? record.domiciliationId
        : null,
  },
]
